<template>
  <div class="container-xl pages" :class="s.container" >
    <div :class="s.pageTitle">{{ law.title }}</div>
    <dl :class="s.list">
      <template
        v-for="section in law.sections"
        :key="section">
        <dt :class="s.title">{{section.title}}</dt>
        <dd :class="s.description">
          <template v-if="!Array.isArray(section.description)" >{{ section.description }}</template>
          <ul v-else :class="s.descriptionList">
            <li
              :class="s.descriptionListItem"
              v-for="text in section.description"
              :key="text"
            >
              {{text}}
            </li>
          </ul>
        </dd>
      </template>
    </dl>
    <Spacer :y="3" />
    <button :class="s.backButton" @click="this.$router.push('/');">TOPページに戻る</button>
    <Spacer :y="3" />
  </div>
</template>

<script>
import law from '@/data/tokushohou.yml';
import {
  Spacer,
} from '@/components/parts';

export default {
  name: 'tokushohou',
  components: {
    Spacer,
  },
  created() {
    // 一番上までスクロール
    window.scrollTo(0, 0);
  },
  data() {
    return {
      law,
    };
  },
};
</script>

<style lang="scss" module="s">
.container {
  width: 100%;
  max-width: 880px;
  margin: 150px auto;
  padding: 0 40px;
  @media (max-width: 576px) {
    margin-top: 70px;
    padding: 0 30px;
  }
}
.pageTitle {
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  @media (max-width: 576px) {
    font-size: 17px;
  }
}
.list {
  margin-top: 1em;
}
.title {
  margin-top: 1em;
  font-size: 10px;
  font-weight: bold;
  @media (max-width: 576px) {
    font-size: 14px;
  }
}
.description {
  margin-top: 3px;
  font-size: 10px;
  white-space: pre-line;
  @media (max-width: 576px) {
    font-size: 12px;
    line-height: 1.5;
  }
}
.descriptionList {
  padding-left: 24px;
  list-style: disc;
}
.descriptionListItem + .descriptionListItem {
  margin-top: 5px;
}
.backButton {
  background-color: transparent;
  color: #333;
  font-size: 20px;
  padding: 10px 30px;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  justify-self: center;
  text-align: center;
}
</style>
